<template>
  <div class="guard-hh">
    <h3 v-if="!isWeiXin">猎头寻求工作申请</h3>
    <div class="step1">
      <van-cell-group>
        <van-field v-model="form.name" maxlength="200" required label="姓名" placeholder="请填写姓名" />
        <van-field v-model="form.mobile"  required label="手机" placeholder="请填写手机号码" />
        <van-field v-model="form.industryId" maxlength="200" required label="擅长行业" placeholder="请填写擅长行业" />
        <van-field v-model="form.functionId" maxlength="200" required label="擅长职能" placeholder="请填写擅长职能" />
        <van-field v-model="form.recentlyCompanyName" maxlength="200" required label="最近猎企名" placeholder="请填写最近猎企名" />
        <van-field v-model="form.currentBasicSalary" maxlength="10" required label="目前底薪" placeholder="请输入目前底薪">
          <span slot="right-icon" style="color:#333;">元</span>
        </van-field>

        <van-field v-model="form.expectBasicSalary" maxlength="10" required label="期望底薪" placeholder="请输入期望底薪">
          <span slot="right-icon" style="color:#333;">元</span>
        </van-field>
        <van-field v-model="form.performance" maxlength="10" required label="年化业绩" placeholder="请输入年化业绩">
          <span slot="right-icon" style="color:#333;">万</span>
        </van-field>

        <van-field v-model="form.purposeCityId"  maxlength="200" required label="意向城市" placeholder="请填写意向城市" />
        
      </van-cell-group>
    </div>

    <div class="btns">
      <van-button type="primary" @click="submit">提交</van-button>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.guard-hh {
  // 隐藏最上方1px边框
  margin-top: -1px;
  padding-bottom: 30px;
  h3 {
    text-align: center;
    padding:10px 0;  
    background: #fff;
    font-size: 18px;
  }
  .btns {
    .van-button {
      width: 100%;
      font-size: 16px;
      background: #E74C3C;
      border:1px solid #E74C3C
    }
    padding: 0 15px;
    margin-top: 20px;
  }
}
</style>
<style lang="scss">
.guard-hh {
  .van-cell {
    display: block;
    .van-field__label {
      width:100%;
    }
  }
  .van-cell-group {
    input {
      font-size: 16px;
    }
  }
  .van-field {
    padding-top: 15px;
    span {
      font-size: 16px;
    }
  }
}
</style>
<script>



import { hhApplies } from "@/api/activity";
import { isMobile } from "@/common/utils";

export default {
  name: "guard-hh-module",
  data() {
    return {
      isWeiXin:false,
      form: {
        name: "",
        mobile:"",
        industryId:"",
        functionId:"",
        recentlyCompanyName:'',
        currentBasicSalary:'',
        expectBasicSalary:'',
        performance:"",
        purposeCityId:""
      }
    };
  },
  watch: {

  },
  components: {
    
  },
  methods: {
    checkRegInfo() {
      if (!this.form.name.trim()) {
        this.$toast("请填写姓名");
        return;
      }
      if (!this.form.mobile.trim()) {
        this.$toast("请填写手机号");
        return;
      }
      if (!isMobile(this.form.mobile.trim())) {
        this.$toast("手机号格式不正确");
        return;
      }
      if (!this.form.industryId.trim()) {
        this.$toast("请填写擅长行业");
        return;
      }
      if (!this.form.functionId.trim()) {
        this.$toast("请填写擅长职能");
        return;
      }
      if (!this.form.recentlyCompanyName.trim()) {
        this.$toast("请填写最近猎企名");
        return;
      }

      if (!(/^\d+(\.\d+)?$/.test(this.form.currentBasicSalary))) {
        this.$toast("请填写正确的目前底薪");
        return;
      }

      if (!(/^\d+(\.\d+)?$/.test(this.form.expectBasicSalary))) {
        this.$toast("请填写正确的期望底薪");
        return;
      }
      if (!(/^\d+(\.\d+)?$/.test(this.form.performance))) {
        this.$toast("请填写正确的年化业绩");
        return;
      }

      if (!this.form.purposeCityId.trim()) {
        this.$toast("请填写意向城市");
        return;
      }

      return true;
    },
    submit(){
    
      if(this.checkRegInfo()){
        hhApplies(this.form).then((res)=>{
          if(res.data){
            this.$router.push({
              path:'success',
              query:{
                type:1
              }
            })
          }
        }).catch(err => {});;
      }
    }
  },
  created() {
    window.scroll(0, 0);
    let isWeiXin = () => {
      return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
    };
    if (isWeiXin()) {
      this.isWeiXin = true;
      this.$store.commit('comp/WX_SHARE',{
            title:'守卫猎头计划开启',
            desc:'猎上网推出五大扶持猎头政策',
            link:window.location.origin + '/hh-wx/activity/guardhunter'
        });
    } else {
      this.isWeiXin = false;
    }
  }
};
</script>
